import { render, staticRenderFns } from "./yzwyh.vue?vue&type=template&id=bfd9a622&scoped=true&"
import script from "./yzwyh.vue?vue&type=script&lang=js&"
export * from "./yzwyh.vue?vue&type=script&lang=js&"
import style0 from "./yzwyh.vue?vue&type=style&index=0&id=bfd9a622&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd9a622",
  null
  
)

export default component.exports